import moment from "moment"
import { TempusDominus, Namespace, DateTime } from "@eonasdan/tempus-dominus"

// Inizializza un campo con Tempus Dominus 6 mantenendo il pattern del vecchio
// datetimepicker: il campo visibile mostra la data nel formato localizzato,
// mentre il valore canonico viene scritto nel campo hidden puntato da data-ref.
function initPicker(el, withTime, lang) {
  // evita la doppia inizializzazione su re-render, turbo:render sostituisce il
  // DOM quindi sui nodi nuovi il flag riparte pulito
  if (el._tdPicker) { return; }

  // formato di visualizzazione esplicito: TD6 di default userebbe "L LT" (data
  // e ora) anche col solo datepicker. Fissiamo DD/MM/YYYY, con orario 24h solo
  // per il datetimepicker
  const displayFormat = withTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy';

  const options = {
    localization: {
      locale: lang,
      hourCycle: 'h23',
      format: displayFormat,
    },
    display: {
      components: {
        clock: withTime,
        hours: withTime,
        minutes: withTime,
        seconds: false,
      },
      buttons: { today: true, clear: true, close: true },
    },
  };

  // il campo arriva da Rails col valore ISO (%Y-%m-%d [%H:%M]), lo azzeriamo
  // prima dell'init e lo reimpostiamo via API, così TD6 lo mostra nel formato
  // localizzato senza tentare il parse del formato ISO
  const iso = (el.value || '').trim();
  el.value = '';

  const picker = new TempusDominus(el, options);
  el._tdPicker = picker;

  if (iso) {
    const m = moment(iso, ['YYYY-MM-DD HH:mm:ss Z', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD'], true);
    if (m.isValid()) {
      picker.dates.setValue(DateTime.convert(m.toDate(), lang));
    }
  }

  // tiene allineato il campo hidden col valore canonico inviato al server
  const canonical = withTime ? 'YYYY-MM-DD HH:mm:ss Z' : 'YYYY-MM-DD';
  el.addEventListener(Namespace.events.change, function(e) {
    const date = e.detail && e.detail.date;
    const $ref = $($(el).data('ref'));
    $ref.val(date ? moment(date).format(canonical) : '');
  });

  // l'addon col calendario apre e chiude il picker. stopPropagation evita che
  // lo stesso click raggiunga il document: TD6 chiude il widget sui click fuori
  // dall'input, e l'addon non ne fa parte, quindi si richiuderebbe subito
  const addon = el.nextElementSibling;
  if (addon) {
    addon.style.cursor = 'pointer';
    addon.addEventListener('click', function(e) {
      e.stopPropagation();
      picker.toggle();
    });
  }
}

function initOnLoad() {
  const lang = $('html').attr('lang') || 'en';

  // bootstrap-fileinput
  $('input.file[type=file]').fileinput({
    theme: 'gly',
    language: lang,
    // nasconde i comandi sulle miniature (cestino/zoom/drag) introdotti dalla 5.x,
    // per mantenere la resa della vecchia 4.2.8; il cestino delle initial preview
    // (allegati già caricati) ha un'opzione dedicata
    initialPreviewShowDelete: false,
    fileActionSettings: {
      showRemove: false,
      showUpload: false,
      showZoom: false,
      showDrag: false,
    },
  });

  // tooltips
  $('[data-rel=tooltip]').tooltip({container: 'body'});
  // popover
  $('[data-rel=popover]').popover({html:true, container: 'body', trigger: 'focus'});

  // datetimepicker / datepicker (Tempus Dominus 6)
  $('[data-provide="datetimepicker"]').each(function() { initPicker(this, true, lang); });
  $('[data-provide="datepicker"]').each(function() { initPicker(this, false, lang); });
}

function startApp() {
  // datetimepicker
  const lang = $('html').attr('lang') || 'en';
  moment.locale(lang);

  if (document) {
    // bootstrap-fileinput 5.x disabilita l'input file mentre genera la preview
    // (lock): un input disabled viene escluso dalla serializzazione del form e
    // l'allegato andrebbe perso se il submit avviene in quella finestra.
    // Lo riabilitiamo prima che il form venga serializzato (capture phase).
    document.addEventListener('submit', function(e) {
      $(e.target).find('.file-input.is-locked input.file[type=file][disabled]')
        .removeAttr('disabled');
    }, true);

    $(document).on('change', '[data-autosubmit=change]', function(event) {
      $(this).closest('form').submit();
    });

    $(document).on('keyup', '[data-autosubmit=keyup]', function(event) {
      const $val = $(this).val();
      if ( $val.length > 3 || $val.length === 0 ) {
        $(this).closest('form').submit();
      }
    });

    $(document).on('change', '.date-filter', function(event) {
      const $dateFilter = $(this);
      const selectedFilter = $(event.target).val();
      $dateFilter.find('[data-date-filter-value]').each((idx, el) => {
        let $el = $(el);
        if ($el.data('dateFilterValue') === selectedFilter) {
          $el.removeClass('hidden');
          $el.find('input').attr('disabled', false);
        } else {
          $el.addClass('hidden');
          $el.find('input').val('').attr('disabled', true);
        }
      })

    })

    // dopo le chiamate ajax jquery
    $(document).ajaxSuccess(function(e) {
      if (window.Rails) { window.Rails.fire(e.target, 'ajax:success'); }
    });
    // rails-ujs
    document.addEventListener("ajax:success", initOnLoad);

    /***
     * DOM ready
     */
    document.addEventListener("turbo:load", initOnLoad);
    document.addEventListener("turbo:render", initOnLoad);
  }

}

const MyApp = {
  start: startApp,
  initOnLoad,
}

export default MyApp;

